"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianSurvey = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var MartianSurvey = (function (_super) {
    __extends(MartianSurvey, _super);
    function MartianSurvey() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.MARTIAN_SURVEY,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 9,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(4).max(); }),
            metadata: {
                cardNumber: 'P38',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(2);
                }),
                description: 'Oxygen must be 4% or lower. Draw two cards.',
                victoryPoints: 1,
            },
        }) || this;
    }
    MartianSurvey.prototype.play = function (player) {
        player.drawCard(2);
        return undefined;
    };
    MartianSurvey.prototype.getVictoryPoints = function () {
        return 1;
    };
    return MartianSurvey;
}(Card_1.Card));
exports.MartianSurvey = MartianSurvey;
//# sourceMappingURL=MartianSurvey.js.map